<template>
    <div class="wrapper">
        <svg-sprite></svg-sprite>
        <sidebar></sidebar>
        <div class="main-panel" :class="{'sidebar-open': $store.getters['sidebar/getSidebar']}">
            <navbar></navbar>
            <div class="content" :class="{'sidebar-closed': $store.getters['sidebar/getSidebar']}">
                <router-view></router-view>
            </div>
        </div>
        <loading-screen></loading-screen>
    </div>
</template>

<script>

import sidebar from "./sidebar/sidebar";
import navbar from "./navbar/navbar";


export default {
    name: "dashboard",
    components: {
        sidebar,
        navbar,
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    @apply .relative .top-0 .h-screen;
}

.main-panel {
    @apply .border-t-2 .border-primary .relative .w-full .min-h-screen;
    background: #f5f6fa;
    -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
    transition: .5s cubic-bezier(.685, .0473, .346, 1);
}

.main-panel.sidebar-open {
    -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
    transition: .5s cubic-bezier(.685, .0473, .346, 1);


    @media(min-width: 1024px) {
        @apply .right-auto;
        -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
        transition: .5s cubic-bezier(.685, .0473, .346, 1);
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
}

.content {
    padding: 89px 30px 30px 30px;
    min-height: calc(100vh - 85px);
    -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
    transition: .5s cubic-bezier(.685, .0473, .346, 1);

    .row {
        @apply .flex .flex-wrap;
    }

    @media(min-width: 1024px) {
        padding-left: 120px;
    }
}

.content.sidebar-closed {
    padding-left: 130px;
    -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
    transition: .5s cubic-bezier(.685, .0473, .346, 1);

    @media(min-width: 1024px) {
        padding-left: 260px;
    }
}


</style>
